import Kurdish from './ku';
import Arabic from './ar';
import English from './en';

export default {Kurdish, Arabic, English};